module.exports = __webpack_public_path__ + "img/plane_in_sky.51727a7e.jpg";